<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="アクセス回線詳細情報"
  >
    <template v-slot:body="{ cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col>
                <h3>契約情報</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <div class="ml-2">
                  <!-- 回線番号 -->
                  <v-row>
                    <v-col>
                      <app-label-group label="回線番号">
                        <template #value>
                          <div class="ml-3">
                            {{ accessLineItem.enumberAct }}
                            <div
                              v-if="
                                accessLineItem.menu === 'PF_ACCESS_GW2' &&
                                accessLineItem.enumberSby
                              "
                            >
                              {{ accessLineItem.enumberSby }}
                            </div>
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                  <!--メニュー-->
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="メニュー"
                        :value="
                          $filter.enumTo(accessLineItem.menu, 'accessLineMenu')
                        "
                      />
                    </v-col>
                  </v-row>

                  <template v-if="isServiceStarted">
                    <!-- サービス開始日を迎えた回線の場合、下記の情報を表示 -->
                    <!--契約者名-->
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="契約者名"
                          :value="
                            $filter.emptyTo(accessLineItem.contractor, '-')
                          "
                        />
                      </v-col>
                    </v-row>
                    <!--エンドユーザ名-->
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="エンドユーザ名"
                          :value="
                            $filter.emptyTo(accessLineItem.endUserName, '-')
                          "
                        />
                      </v-col>
                    </v-row>
                    <!--事業所名(拠点名)-->
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="事業所名(拠点名)"
                          :value="$filter.emptyTo(accessLineItem.office, '-')"
                        />
                      </v-col>
                    </v-row>
                    <!--住所-->
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="住所"
                          :value="$filter.emptyTo(accessLineItem.address, '-')"
                        />
                      </v-col>
                    </v-row>
                    <!--ビル名-->
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="ビル名"
                          :value="$filter.emptyTo(accessLineItem.building, '-')"
                        />
                      </v-col>
                    </v-row>
                  </template>
                </div>
              </v-col>

              <v-col cols="6">
                <div class="ml-2">
                  <!--帯域値-->
                  <v-row>
                    <v-col>
                      <app-label-group label="帯域値">
                        <template #value>
                          <div class="ml-3">
                            <template
                              v-if="accessLineItem.bandwidthType === 'BURST10'"
                            >
                              バースト10
                            </template>
                            <template
                              v-else-if="
                                accessLineItem.bandwidthType === 'BURST100'
                              "
                            >
                              バースト100
                            </template>
                            <template
                              v-else-if="
                                accessLineItem.bandwidthType === 'BESTEFFORT'
                              "
                            >
                              -
                            </template>
                            <template v-else-if="accessLineItem.bandwidth">
                              {{
                                $filter.bandwidthTo(
                                  accessLineItem.bandwidth,
                                  "Mbps"
                                )
                              }}
                            </template>
                            <template v-else> - </template>
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                  <!--QoS-->
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="QoS"
                        :value="$filter.emptyTo(accessLineItem.qos, '-')"
                      />
                    </v-col>
                  </v-row>
                  <!--VLAN制御-->
                  <v-row>
                    <v-col>
                      <app-label-group
                        label="VLAN制御"
                        :value="
                          $filter.emptyTo(accessLineItem.vlanControl, '-')
                        "
                      />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-6">
              <v-col>
                <v-tabs
                  v-model="tabValue"
                  hide-slider
                  class="border-s-sm border-t-sm border-e-sm"
                >
                  <v-tab
                    text="トラフィック"
                    value="traffic"
                    v-if="
                      accessLineItem.menu !== 'MULTI_CLOUD_GW' &&
                      contractSummary.isTrafficInfo
                    "
                  />
                  <v-tab text="設定上限値" value="upperLimit" />
                </v-tabs>
                <v-tabs-window
                  v-model="tabValue"
                  class="border-s-sm border-b-sm border-e-sm tabs-height"
                >
                  <v-tabs-window-item value="traffic">
                    <traffic
                      line-type="ACCESS"
                      :line="{ enumberMainAct: accessLineItem.enumberAct }"
                    />
                  </v-tabs-window-item>
                  <v-tabs-window-item value="upperLimit">
                    <upper-limit
                      upperLimitManageUnit="ACCESS"
                      :enumber="accessLineItem.enumberAct"
                    />
                  </v-tabs-window-item>
                </v-tabs-window>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { BandwidthListGetEntity } from "@/apis/AccessLineApi";
import { mapState } from "vuex";
import Traffic from "@/components/operation-tool/Traffic.vue";
import UpperLimit from "@/components/operation-tool/UpperLimit.vue";

export default defineComponent({
  name: "AccessLineReference",
  components: { Traffic, UpperLimit },
  props: {
    /** 表示対象のアクセス回線情報 */
    accessLineItem: {
      type: Object as PropType<BandwidthListGetEntity>,
      required: true,
    },
    /** サービス開始済フラグ：開始済の場合はtrue */
    isServiceStarted: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "traffic" as "traffic" | "upperLimit",
    };
  },
  computed: {
    ...mapState("user", {
      contractSummary: "contractSummary",
    }),
  },
});
</script>

<style lang="scss" scoped>
.tabs-height {
  min-height: 10vh;
}
</style>
